<template lang="pug">
.middle-block()
    .jump-btn
</template>
<script>
export default {
  mounted() {
    window.location.href = 'alipays://platformapi/startapp?appId=2017050407110255&query=redirectUrl%3Dhttps%253A%252F%252Fm.hellobike.com%252FAppPlatformH5%252Flatest%252Findex.html%2523%252Fvip%252Fv2%252Ftransfer%253FneedLogin%253Dtrue%2526openType%253Dwebview%26h5Login%3D1';
  },
  methods: {
  },
};
</script>
<style lang="less" scoped>
.middle-block {
  background-image: url(https://m.hellobike.com/resource/helloyun/08345/rGcUs0ylaY.png);
  background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
}
</style>
